import { futureDates, currDate } from './carousel-react/src/utils/date';


const mainCarouselConfigObj={
    theme: window.powersearchUserSettings.theme,
    usePowersearch: true,
    genre: '',
    sort: '',
    // minDate: '',
    // maxDate: '',
    eventGuid: '',
  
    // genre: 'pop',
    // sort: 'venue',
    minDate: currDate(),
    maxDate: futureDates(window.powersearchUserSettings.carouselOpts.timeframe),
    // eventGuid: 'd0bdfa43-a32b-11eb-9109-120568a44dc9',
    menuOpts:  window.powersearchUserSettings.carouselOpts.menuOptions,
    timeframe: window.powersearchUserSettings.carouselOpts.timeframe,
    distance: window.powersearchUserSettings.powersearchBarOpts.distanceOpts.defaultDistance,
    lat: window.powersearchUserSettings.defaultLocation.lat,
    lon: window.powersearchUserSettings.defaultLocation.lon,
    // venueGuid: '',
    gMapApiKey: 'AIzaSyAQCEUvub3Z1INT7fJqrnyJPcmbPOShK4A',
    // eslint-disable-next-line max-len
    hearbyApiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJzYW1wbGUtYXV0aC1zZXJ2ZXIiLCJjbGllbnRfaWQiOjg1LCJ0b2tlbl9pZCI6MTEsImV4cCI6MTY1MTk2MjE1NC43OTUzMjU1fQ.Bf6e92JV79hPJsYZpeJ09NB_FkVwLdpp1QBSrai3CxlFMu3UiM75YjD9yVSoMjrE5GHr795E2oe0yLB7yru242-rZPjFkAh1k1qSKGTbt3vYSdRx6ZEdwSIYJfLIzzPt_jfKUljq18abp6H7pS3Sb7jBsVwztZVm0wGPEl7Z4WUnSi09xlcMn7q7v5Cff0yfRpcsN8ojpo8d7WZkF9mRgmCI5SgCwKdplTKcDDlueYbAB8KuL_tBc7ETLBpMmqjv1TiaoyKrDpdg6Ix7ZXoiQzLS9YkvJdTg-dp5gptDUVERRrA9ig5AiySAuJzYbi03MvhlWS7RY_2Vee8qz2Iru5fRypsfB3G5YeJTBH-3qu-6nGvYu4bwI65AFVbp6Rc1-CkUBzCnkibHyWUIQXGYPhRcAqN6cN9J5j3fHeVeBhqmG2wPioRGw7BMCxzdqcW3ZsD4hBZWCsGsbveSocgDA6Eb7xiFPtkYJnlR11Fw-ta2KQMszq1wbYAq5wS_wlQLGgDAoGkVpdbc0RAbExYeHEmhVGUffnYjJ07L8K03UNkRS9Rn_I9gLP3qqILNtwKFzMaYeUxl8h_hKSOkudm3eKZS0DFlrgGLum--JKhlnoVfFQYhz0DF5K1dQcLdUfg4KgY9fq_6QKbzSCJ5goHqUpGcgFUSJM-TVAl7rTypYJc',
    title: window.powersearchUserSettings.carouselOpts.carouselTitle,
    sliderConfigs: '',
    widgetId: '1',
    // numSlides: window.powersearchUserSettings.carouselOpts.numSlides,
    numSlides: window.powersearchUserSettings.carouselOpts.numSlides,
    breakpoints: '',
  };

export {mainCarouselConfigObj}